export type LiveConnection = {
  readonly readyState: number;
  onopen: (() => void) | null;
  onmessage: ((event: { data: unknown }) => void) | null;
  onclose: (() => void) | null;
  onerror: (() => void) | null;
  send(data: string): void;
  close(): void;
};

export type LiveConnectionFactory = (url: string) => LiveConnection;

export const LIVE_CONNECTING = 0;
export const LIVE_OPEN = 1;

let factory: LiveConnectionFactory = () => { throw new Error('Соединение не настроено'); };

export function configureLiveConnection(next: LiveConnectionFactory): void {
  factory = next;
}

export function openLiveConnection(url: string): LiveConnection {
  return factory(url);
}
